import { useEffect, useState } from 'react';
import NewCustomOrder from './NewCustomOrder';
import ExoDialog from '../exo/ExoDialog';

const NewOrder = ({
  open,
  onClose,
  orders,
  setOrders,
  offerId = 0,
  startData,
  onUpdate,
}) => {
  function handleClose() {
    onClose();
  }

  useEffect(() => {
    if (offerId > 0) {
    }
  }, []);

  return (
    <ExoDialog open={open} onClose={() => onClose()}>
      <NewCustomOrder
        startData={startData}
        orders={orders}
        setOrders={setOrders}
        onClose={handleClose}
        onUpdate={onUpdate}
      />
    </ExoDialog>
  );
};

export default NewOrder;
